interface FallbackBlockProps {
  blocktype: string;
}
export const FallbackBlock = ({ blocktype }: FallbackBlockProps) => {
  // eslint-disable-next-line no-console
  console.warn(`No component found for: ${blocktype}`);
  return null;
};
